/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-console */
import React, {useEffect, useState} from 'react'
import {PageTitle} from 'layout/master-layout'
import {KTTab} from 'helpers/ui-components/KTTab'
import Spinner from 'layout/common/Spinner'
import {useAuth} from 'context/AuthProvider'
import {
 IEditSkuProps,
 IProductFormConfig,
 IProductVariantField,
} from 'models/ProductManagement'
import {
 fetchProductConfig,
 productUpsert,
 fetchProductCategory,
 fetchProductSubCategory,
 fetchProductDetails,
} from 'utils/api/productManagementService'
import {useTranslation} from 'react-i18next'
import {
 ColumnProps,
 IFileObject,
 IFormField,
} from 'models/Common'
import {
 Button,
 KTSVG,
 Model,
 Select2DropdownField,
} from 'helpers'
import {toast} from 'react-toastify'
import KTTable from 'helpers/ui-components/KTTable'
import {useForm} from 'react-hook-form'
import GenericFormBuilder from 'helpers/ui-components/GenericFormBuilder'
import AddSku from './AddSku'
import {createPayload} from 'utils/helpers/genericForm'
import {useNavigate} from 'react-router-dom'
import IDropdown from 'models/dropdown'
import {IFields} from 'models/GenericForm'
import {KTImage} from 'helpers/ui-components/KTImage'
import {getFileTypeFromFileName} from 'utils/helper'
import {getProductCataloguePath} from './productCatalogueRoutes'

type IProps = {
 selectedProductId: number | null
 setSelectedProductId?: (newState: number | null) => void
 returnPath?: string
}

const AddProductPage = (props: IProps) => {
 const {t} = useTranslation()
 const navigate = useNavigate()
 const returnPath =
  props.returnPath ?? getProductCataloguePath()
 const {userData} = useAuth()
 const accessDetails =
  userData?.userSubModule?.productCatalogue?.homePage
 const [loader, setLoader] = useState(false)
 const [showSKUImageModel, setSKUImageModel] =
  useState(false)
 const [activeTab, setActiveTab] = useState('basic_details')
 const [productSkuList, setProductSkuList] = useState<
  IFormField[]
 >([])
 const [skuImages, setSkuImages] = useState<string[]>([])
 const [selectedSku, setSelectedSku] =
  useState<IEditSkuProps | null>(null)

 const [uploadedFileData, setUploadedFileData] =
  useState<IFileObject>({})

 const [tableColList, setTableColList] = useState<
  Array<ColumnProps<IFormField>>
 >([])
 const [productConfig, setProductConfig] =
  useState<IProductFormConfig | null>(null)
 const [productCategoryList, setProductCategoryList] =
  useState<IDropdown[]>([])
 const [productSubCategoryList, setProductSubCategoryList] =
  useState<IDropdown[]>([])

 const canAdd =
  accessDetails?.section?.productDetails?.canAdd
 const isDisabled =
  !accessDetails?.section?.productDetails?.canEdit ||
  !canAdd

 const tabList = [
  {
   title: t('productMgmt.basicOfProducts'),
   id: 'basic_details',
   icon: '',
  },
 ]

 const {
  register,
  control,
  unregister,
  reset,
  getValues,
  watch,
  setValue,
  handleSubmit,
  formState: {errors},
 } = useForm({
  mode: 'all',
  reValidateMode: 'onChange',
 })

 const handleTabClick = async (index: string) => {
  setActiveTab(index)
 }

 const handleAddUpdateSku = (index?: number) => {
  if (index === undefined) {
   return
  }
  if (index === -2) {
   setSelectedSku(null)
   return
  }
  console.log('index', index)
  const formConfig = {...productConfig}
  const skuConfig: IEditSkuProps = {
   index,
   skuConfig: [],
   skuId: 0,
  }
  if (index === -1) {
   skuConfig.skuConfig = formConfig?.variant_fields
  } else if (index >= 0) {
   if (props.selectedProductId) {
    const skuData =
     formConfig?.product_variant_fields?.[index]
    skuConfig.skuId = skuData?.variant_metadata.variant_id
    if (skuData?.variant_fields) {
     skuConfig.skuConfig = skuData.variant_fields
    }
   }
   if (skuConfig.skuConfig?.length === 0) {
    skuConfig.skuConfig = formConfig?.variant_fields
   }
  }
  setSelectedSku({...skuConfig})
 }

 const handleSkuSaved = (
  index: number,
  payload: IFormField
 ) => {
  if (!productConfig?.product_variant_fields?.[index]) {
   return
  }
  setProductConfig((prev) => {
   if (!prev?.product_variant_fields?.[index]) {
    return prev
   }
   const updatedVariantFields = prev.product_variant_fields[
    index
   ].variant_fields.map((field) => ({
    ...field,
    ...(payload[field.label_key] !== undefined && {
     value: payload[field.label_key],
    }),
   }))
   const updatedProductVariantFields = [
    ...prev.product_variant_fields,
   ]
   updatedProductVariantFields[index] = {
    ...prev.product_variant_fields[index],
    variant_fields: updatedVariantFields,
   }
   return {
    ...prev,
    product_variant_fields: updatedProductVariantFields,
   }
  })
 }

 const getProductConfig = async (
  productSubCategoryId: string
 ) => {
  setLoader(true)
  setProductConfig(null)
  setUploadedFileData({})
  // clear form fields
  const prevFields = getValues()
  for (const field in prevFields) {
   if (
    ![
     'business_group_id',
     'line_of_business_id',
     'category',
    ].includes(field)
   ) {
    unregister(field) // Unregister fields not in the exception list
   }
  }
  console.log('sdf', getValues())
  const res: IProductFormConfig | null =
   await fetchProductConfig(productSubCategoryId)
  if (res) {
   setProductConfig(res ?? null)
  }
  setLoader(false)
 }

 const getProductDetails = async () => {
  setLoader(true)
  setProductConfig(null)
  const res: IProductFormConfig | null =
   await fetchProductDetails({
    product_id: props.selectedProductId,
   })
  if (res) {
   let productConfigRes: IProductFormConfig | null = null
   const skuList: IFormField[] = []
   if (res?.product_variant_fields) {
    const lineOfBusiness = res?.product_fields.find(
     (product) =>
      product.label_key === 'line_of_business_id'
    )
    if (lineOfBusiness?.value) {
     productConfigRes = await fetchProductConfig(
      lineOfBusiness.value
     )
    }
    res?.product_variant_fields.map(
     (val: IProductVariantField, i) => {
      const skuFormData: IFormField = {}
      const skuFileData: IFileObject = {}
      const sigendUrls: string[] = []
      val?.variant_fields?.map((field: IFields) => {
       if (val.variant_metadata) {
        skuFormData[field.label_key] = field.value
        if (field?.field_type === 'FILE_FIELD') {
         const fileArr: IFileObject = {}
         if (
          Array.isArray(field?.value) &&
          field.value.length > 0
         ) {
          field.value.map((img, index) => {
           skuFileData[`${field.label_key}.${index}`] = {
            filePath: img,
            fileName: img,
            fileType: getFileTypeFromFileName(img),
            signedUrl: field?.presigned_url?.[index] ?? '',
           }
          })
         } else {
          if (field?.value) {
           skuFileData[`${field.label_key}`] = {
            filePath: field.value,
            fileName: field.value,
            fileType: getFileTypeFromFileName(field.value),
            signedUrl: field?.presigned_url ?? '',
           }
          }
         }
        }
       }
      })
      skuList.push({
       skuFileData,
       skuFormData,
       skuTableData: {...val.variant_metadata},
      })
     }
    )
   }
   setProductConfig({
    ...res,
    ...(productConfigRes?.variant_fields && {
     variant_fields: productConfigRes?.variant_fields,
    }),
   })
   console.log('skuList', skuList)
   setProductSkuList(skuList)
  }
  setLoader(false)
 }

 const skuListTableConfig = async () => {
  setLoader(true)
  const columns: Array<ColumnProps<IFormField>> = [
   {
    key: 'variant_id',
    title: t(
     'orderManagement.orderDetails.itemsTable.skuId'
    ),
    className: 'w-[120px] text-center',
    render: (_, record, index) => {
     return record?.skuTableData?.variant_id > 0
      ? record?.skuTableData?.variant_id
      : '-'
    },
   },
   {
    key: 'variant_name',
    title: t(
     'orderManagement.orderDetails.itemsTable.productName'
    ),
    className: 'w-[300px]',
    render: (_, record, index) => {
     return (
      <div className='flex items-center w-full'>
       <div
        className='relative w-[50px] h-[50px] flex items-center justify-center border border-[#4E83E4]
        rounded-lg  mr-2'
       >
        {record?.skuTableData?.variant_images?.length >
         0 && (
         <>
          {record.skuTableData.variant_images.length - 1 >
           0 && (
           <span
            className='absolute -right-2.5 -top-2.5 rounded-full w-6 h-6 flex items-center justify-center bg-[#517A22] 
        font-medium text-xs border border-[##E6EBF0] text-white'
           >
            +{record.skuTableData.variant_images.length - 1}
           </span>
          )}
          <KTImage
           width={50}
           height={50}
           className={
            'max-w-[45px] max-h-[45px] rounded-lg'
           }
           src={record?.skuTableData?.variant_images?.[0]}
           alt=''
           onClick={() => {
            setSkuImages(
             record?.skuTableData?.variant_images ?? []
            )
           }}
          />
         </>
        )}
       </div>
       {record?.skuTableData?.variant_name}
      </div>
     )
    },
   },
   {
    key: 'variant_sku',
    title: t('common.skuSize'),
    className: 'w-[120px] text-center',
    render: (_, record, index) => {
     return record?.skuTableData?.variant_sku
    },
   },
   {
    key: 'uom',
    title: t('common.skuUnit'),
    render: (_, record, index) => {
     return record?.skuTableData?.uom
    },
   },
   {
    key: 'action',
    title: t('productMgmt.productListCol.action'),
    className: 'w-[100px] text-center',
    render: (_, record, index) => {
     return (
      <div className='flex items-center justify-center w-full'>
       <button
        type='button'
        disabled={false}
        color='blue'
        className={`text-center !bg-transparent text-sm text-[#4E83E4] font-medium underline underline-offset-auto 
             disabled:underline-0 disabled:text-[#C5CED6]`}
        onClick={() => {
         handleAddUpdateSku(index)
        }}
       >
        {canAdd
         ? t('productMgmt.productListCol.edit')
         : t('productMgmt.productListCol.view')}
       </button>
      </div>
     )
    },
   },
  ]
  setTableColList(columns)
  setLoader(false)
 }

 const submitFormData = async (formData: IFormField) => {
  if (
   productSkuList?.length > 0 &&
   productConfig?.product_fields
  ) {
   setLoader(true)
   const productPayload = await createPayload(
    productConfig.product_fields,
    formData,
    uploadedFileData
   )
   const skuList: IFormField[] = []
   productSkuList.map((sku) => {
    if (!sku?.skuTableData?.variant_id) {
     skuList.push({...sku.skuFormData})
    }
   })
   const res = await productUpsert({
    product: {
     ...productPayload,
     ...(props.selectedProductId && {
      id: props.selectedProductId,
     }),
    },
    variants: skuList,
   })
   if (res) {
    toast.success(res)
    if (props.setSelectedProductId) {
     props.setSelectedProductId(null)
    } else {
     navigate(returnPath)
    }
   }
   setLoader(false)
  } else {
   toast.error(t('errors.pleaseAddSku'))
  }
 }

 const resetForm = async () => {
  reset()
 }

 const getProductSubCategory = async (
  productCategoryId: string
 ) => {
  setLoader(true)
  setValue('category', '')
  setValue('line_of_business_id', '')
  setProductSubCategoryList([])
  //   setProductConfig(null)
  const res: IDropdown[] = await fetchProductSubCategory(
   productCategoryId
  )
  if (res) {
   setProductSubCategoryList(res)
  }
  setLoader(false)
 }

 useEffect(() => {
  setUploadedFileData({})
  const getProductCategories = async () => {
   setLoader(true)
   const res: IDropdown[] = await fetchProductCategory()
   if (res) {
    setProductCategoryList(res)
   }
   setLoader(false)
  }
  if (props.selectedProductId) {
   void getProductDetails()
  } else {
   void getProductCategories()
  }
 }, [props.selectedProductId])

 useEffect(() => {
  void skuListTableConfig()
 }, [productSkuList])

 useEffect(() => {
  if (skuImages.length > 0) {
   setSKUImageModel(true)
  }
 }, [skuImages])

 const businessGroup = getValues('business_group_id')
 const lineOfBusiness = getValues('line_of_business_id')

 const checkAddSku = Boolean(
  businessGroup && lineOfBusiness
 )

 return (
  <>
   {loader && <Spinner />}
   <Model
    show={showSKUImageModel}
    showHeader={false}
    closeBtnClass='absolute right-4 top-2 !bg-[#E6EBF0] !rounded-3xl w-7 h-7 !text-[#33393D]'
    header={''}
    close={() => {
     setSKUImageModel(false)
    }}
    modelClass='md:w-[600px]'
    modelContainerClass='!rounded-2xl'
    modelBodyClass='p-10'
   >
    <div className='w-full'>
     <div className='w-full'>
      <p className='text-[#171B1F] text-left font-bold text-2xl'>
       {t('productMgmt.skuImages')}
      </p>
      <div
       className='w-full my-7 flex items-center border border-[#E6EBF0] py-3 px-4
        rounded-lg'
      >
       {skuImages.map((url, key) => (
        <div
         key={key}
         className='relative w-[100px] h-[100px] flex items-center justify-center border border-[#E6EBF0]
        rounded-lg  mr-4'
        >
         <span
          className='absolute right-0 top-0 rounded-tr-lg rounded-bl-lg w-6 h-6 flex items-center justify-center bg-[#CC293F] 
        font-medium text-xs border border-[#E6EBF0] bg-[#CC293F] text-white'
         >
          <KTImage
           width={20}
           height={20}
           className={'w-5 h-5'}
           src={'/media/icons/view_icon.jpg'}
           alt=''
          />
         </span>
         <KTImage
          width={100}
          height={100}
          className={'w-full h-full'}
          src={url}
          alt=''
          onClick={() => {
           // setSkuImages(img)
          }}
         />
        </div>
       ))}
      </div>
     </div>
    </div>
   </Model>
   {selectedSku && (
    <AddSku
     canAdd={canAdd}
     isDisabled={isDisabled}
     loggedInUserId={userData?.userId}
     selectedSku={selectedSku}
     handleAddUpdateSku={handleAddUpdateSku}
     onSkuSaved={handleSkuSaved}
     setProductSkuList={setProductSkuList}
     productSkuList={productSkuList}
     setLoader={setLoader}
    />
   )}
   <div className={`w-full min-h-full`}>
    <div className='my-6 border-[#E6EBF0] border-b'>
     <p className='text-[#2F2F2F] text-xl font-medium'>
      {t('productMgmt.addProduct.title')}
     </p>
    </div>
    <form
     method='POST'
     action=''
     onSubmit={handleSubmit(submitFormData)}
    >
     <KTTab
      activeTabId={activeTab}
      controlledTab
      disableHash
      containerClass='my-6 '
      tabHeaderContainerClass='mb-6 !justify-between'
      tabHeaderClass='px-2 items-end'
      activeClass='text-[#4E83E4] font-semibold border-b-[3px] border-[#4E83E4] '
      onClick={handleTabClick}
      tabs={tabList}
      tabContent={
       <div>
        <div className='grid md:grid-cols-3 gap-5 w-full mt-6 border-b border-[#E6EBF0] pb-6'>
         {!props.selectedProductId && (
          <>
           <Select2DropdownField
            label={t(
             'productMgmt.addProduct.businessGroup'
            )}
            labelClassName='padding-0 text-[#4E83E4] text-xs !font-medium'
            className={`${
             isDisabled
              ? '!text-[#33393D] font-medium '
              : 'font-normal !text-[#33393D]'
            } boxed-select2 !font-medium  relative block text-lg border-0  !rounded-l-lg`}
            wrapperClassName='relative w-full'
            inputWrapperClassName='pl-4 py-2 px-4 '
            required={true}
            disabled={false}
            isClearable={false}
            isSearchable={true}
            control={control}
            customStyle={{
             transition: 'unset',
             boxShadow: 'unset',
             border: '0px',
             borderRadius: '0px',
             padding: '0px 0px 0px 0px',
             minHeight: 'auto',
            }}
            data={productCategoryList}
            rules={{
             validate: {
              required: (v: string) => {
               if (v === '')
                return `${t('helperText.plsSelect')} ${t(
                 'productMgmt.addProduct.businessGroup'
                )}`
              },
             },
             onChange: (e: {target: {value: string}}) => {
              void getProductSubCategory(e.target.value)
              setProductConfig(null)
             },
            }}
            id={`business_group_id`}
            name={`business_group_id`}
            OptionValueKey='id'
            OptionLabelKey='name'
            placeholder={`${t('helperText.select')} ${t(
             'productMgmt.addProduct.businessGroup'
            )}`}
            errors={errors}
           />
           <Select2DropdownField
            label={t(
             'productMgmt.addProduct.lineOfBusiness'
            )}
            labelClassName='padding-0 text-[#4E83E4] text-xs !font-medium'
            className={`${
             isDisabled
              ? '!text-[#33393D] font-medium '
              : 'font-normal !text-[#33393D]'
            } boxed-select2 !font-medium  relative block text-lg border-0  !rounded-l-lg`}
            wrapperClassName='relative w-full'
            inputWrapperClassName='pl-4 py-2 px-4 '
            required={true}
            disabled={false}
            isClearable={false}
            isSearchable={true}
            control={control}
            customStyle={{
             transition: 'unset',
             boxShadow: 'unset',
             border: '0px',
             borderRadius: '0px',
             padding: '0px 0px 0px 0px',
             minHeight: 'auto',
            }}
            data={productSubCategoryList}
            rules={{
             validate: {
              required: (v: string) => {
               if (v === '')
                return `${t('helperText.plsSelect')} ${t(
                 'productMgmt.addProduct.lineOfBusiness'
                )}`
              },
             },
             onChange: (e: {target: {value: string}}) => {
              void getProductConfig(e.target.value)
             },
            }}
            id={`line_of_business_id`}
            name={`line_of_business_id`}
            OptionValueKey='id'
            OptionLabelKey='name'
            placeholder={`${t('helperText.select')} ${t(
             'productMgmt.addProduct.lineOfBusiness'
            )}`}
            errors={errors}
           />
          </>
         )}
         {productConfig?.product_fields &&
          productConfig?.product_fields?.length > 0 && (
           <GenericFormBuilder
            isDisabled={isDisabled}
            itemConfigList={[
             {
              item_identifier: 'product_details',
              fields: productConfig?.product_fields ?? [],
             },
            ]}
            excludedFields={
             props.selectedProductId
              ? []
              : ['business_group_id', 'line_of_business_id']
            }
            uploadedFileData={uploadedFileData}
            setUploadedFileData={setUploadedFileData}
            itemIdentifier={'product_details'}
            setLoader={setLoader}
            register={register}
            unregister={unregister}
            control={control}
            getValues={getValues}
            errors={errors}
            watch={watch}
            setValue={setValue}
            className=''
           />
          )}
        </div>
       </div>
      }
     />
     <div className='w-full'>
      <KTTable
       data={productSkuList}
       columns={tableColList}
       headerClass='bg-[#80868C]'
       headerColClass='!border-0 text-left'
       colClass='text-[#33393D] !text-sm font-normal !border-0 !py-3'
       tableClass=''
       rowClass='even:bg-[#E6EBF0]'
       showPagination={false}
      />
      {canAdd && (
       <div
        className='flex text-lg font-bold items-center w-[200px] cursor-pointer mt-4'
        onClick={() => {
         if (checkAddSku) {
          handleAddUpdateSku(-1)
         }
        }}
        style={{color: checkAddSku ? '#4E83E4' : '#9CA3AF'}}
       >
        <KTSVG
         path={`/media/icons/plus.svg`}
         svgClassName={`w-4 h-4`}
        />
        <div>{t('productMgmt.addSKU.title')}</div>
       </div>
      )}
     </div>

     <div className='w-full mt-10'>
      {canAdd && (
       <div className='flex items-center justify-end'>
        {productConfig?.product_fields && (
         <>
          <Button
           type='button'
           disabled={false}
           onClick={resetForm}
           color='white'
           className='text-center py-[9px] px-6 bg-[#FFEBED] 
          !rounded-lg text-base text-[#CC293F] hover:!bg-[#CC293F] hover:text-white font-semibold border-[#CC293F] mr-2'
          >
           {t('common.discard')}
          </Button>
          <Button
           type='submit'
           disabled={false}
           color='blue'
           className='text-center py-[9px] px-6 bg-[#4E83E4] 
          hover:bg-white hover:text-[#4E83E4] !rounded-lg text-base text-white font-semibold border-[#4E83E4]'
          >
           {t('common.save')}
          </Button>
         </>
        )}
       </div>
      )}
     </div>
    </form>
   </div>
  </>
 )
}

export default function AddProductPageWrapper(
 props: IProps
) {
 // for using different languages and changing the text in to other languages
 // const intl = useIntl()
 const {t} = useTranslation()
 const navigate = useNavigate()
 const returnPath =
  props.returnPath ?? getProductCataloguePath()

 const handleCatalogueBreadcrumbClick = () => {
  if (props.setSelectedProductId) {
   props.setSelectedProductId(null)
   return
  }
  navigate(returnPath)
 }

 return (
  <div
   className={`${
    !props.selectedProductId && 'container relative'
   }`}
  >
   <div
    className={`${
     !props.selectedProductId &&
     'px-[72px] pt-6 pb-10 bg-white'
    }`}
   >
    <PageTitle
     breadcrumbContainerClass={
      'flex text-[#5A6066] text-sm font-normal items-center pb-6 border-[#E6EBF0] border-b'
     }
     breadcrumbs={[
      {
       title: t('breadCrumbs.home'),
       path: '/home-page',
       isActive: false,
      },
      {
       title: t('breadCrumbs.catalogue'),
       path: returnPath,
       isActive: false,
       ...(props.selectedProductId && {
        onClick: handleCatalogueBreadcrumbClick,
       }),
      },
      {
       title: props.selectedProductId
        ? t('breadCrumbs.productDetails')
        : t('breadCrumbs.addNewProduct'),
       path: '',
       isActive: true,
      },
     ]}
     description='Welcome'
    >
     {t('breadCrumbs.addNewProduct')}
    </PageTitle>
    <AddProductPage {...props} />
   </div>
  </div>
 )
}
